import { Box } from '@mui/material';
import { type FC } from 'react';
import { CommonIcon } from '../common/CommonIcon';

interface RitualCardIconProps {
    icon: string;
    backgroundColor?: string;
    size?: number;
    color?: string;
}

export const RitualCardIcon: FC<RitualCardIconProps> = ({
    icon,
    backgroundColor = 'transparent',
    size = 20,
    color = 'var(--tg-theme-text-color)',
}) => {
    return (
        <Box
            sx={{
                width: 32,
                height: 32,
                borderRadius: '8px',
                backgroundColor,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }}
        >
            <CommonIcon icon={icon} type="outlined" size={size} color={color} />
        </Box>
    );
};
